import { Injectable } from '@angular/core';
import { BaseDbService } from './user.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { Invitation } from '../models/invitation';
import * as firebase from 'firebase';
import { UserGroupService } from './user-group.service';

@Injectable({
  providedIn: 'root'
})
export class InvitationService extends BaseDbService {

  constructor(
    protected db: AngularFireDatabase,
    private usergroupService: UserGroupService) {
    super(db, "invitations");
  }

  create(invitation: Invitation) {
    invitation.createdOn = firebase.database.ServerValue.TIMESTAMP;
    return this.getListRef().push(invitation);
  }

  getInvitationsByEmail(email: string) {
    return this.db.list(`${this.dbPath}`, ref => ref.orderByChild("inviteeEmail").equalTo(email));
    // return this.getInvitations(list)
  }

  getInvitationByGroup(groupId: string) {
    return this.db.list(`${this.dbPath}`, ref => ref.orderByChild("groupId").equalTo(groupId));
  }

  accept(invitationId: string) {
    this.getById(invitationId).valueChanges().subscribe(res => {
      if (res != null) {
        var userId = firebase.auth().currentUser.uid;
        this.usergroupService.add(userId, res.groupId).then(res => {
          this.getById(invitationId).remove();
        })
      }
    })
  }

  decline(invitationId: string) {
    return this.getById(invitationId).remove();
  }

  private getInvitations(list): Promise<Invitation[]> {
    return new Promise((resolve, reject) => {
      list.valueChanges().subscribe(res => {
        var invitations: Invitation[] = [];
        res.forEach(r => {
          invitations.push(new Invitation(r));
        });
        resolve(invitations);
      }, reject);
    });
  }
}
